export const PAGE_BREAKPOINT_SM = 480
export const PAGE_BREAKPOINT_MD = 768
export const PAGE_BREAKPOINT_DESK = 1280
export const PAGE_BREAKPOINT_XL = 1440
export const PAGE_BREAKPOINT_FHD = 1920

export const ALL_LANGUAGES_AVAILABLE = ["en", "es", "de"]
